module.exports = __webpack_public_path__ + "e45286eb737441912bd59d1466247a43.png";